import React, { useEffect } from 'react';
import {
  Banner,
  Brand,
  Bullseye,
  Card,
  CardTitle,
  CardBody,
  DescriptionList,
  DescriptionListGroup,
  DescriptionListTerm,
  DescriptionListDescription,
  EmptyState,
  EmptyStateBody,
  Gallery,
  Spinner,
  Title
} from '@patternfly/react-core';
import Linkify from 'linkify-react';
import l_gallery_GridTemplateColumns_min from '@patternfly/react-tokens/dist/esm/l_gallery_GridTemplateColumns_min';
import Image from "./tornados.png";
import SearchIcon from '@patternfly/react-icons/dist/esm/icons/search-icon';

const Contacts = ({ children }) => {
  const [boardData, setBoardData] = React.useState(null);
  const [boardLoading, setBoardLoading] = React.useState(true);
  const [coach10UPassanteData, setCoach10UPassanteData] = React.useState(null);
  const [coach10UPassanteLoading, setCoach10UPassanteLoading] = React.useState(true);
  const [coach12UBeardData, setCoach12UBeardData] = React.useState(null);
  const [coach12UBeardLoading, setCoach12UBeardLoading] = React.useState(true);
  const [coach12UBeckData, setCoach12UBeckData] = React.useState(null);
  const [coach12UBeckLoading, setCoach12UBeckLoading] = React.useState(true);
  const [coach14UGentileData, setCoach14UGentileData] = React.useState(null);
  const [coach14UGentileLoading, setCoach14UGentileLoading] = React.useState(true);
  const [coach14UGreenData, setCoach14UGreenData] = React.useState(null);
  const [coach14UGreenLoading, setCoach14UGreenLoading] = React.useState(true);
  const [coach16UCulliganData, setCoach16UCulliganData] = React.useState(null);
  const [coach16UCulliganLoading, setCoach16UCulliganLoading] = React.useState(true);
  const [err, setErr] = React.useState(null);

  useEffect(() => {
    // Fetch data for Travel Coaches and Players, and Board President
    fetchBoardPresident();
    fetch10UPassanteCoaches();
    fetch12UBeardCoaches();
    fetch12UBeckCoaches();
    fetch14UGentileCoaches();
    fetch14UGreenCoaches();
    fetch16UCulliganCoaches();
  }, []);

  const fetchBoardPresident = () => {
    //    fetch(`http://softball-pi4/db/GetTravelHeadCoach10U.php`)
    fetch(`https://www.ehtsoftball.com/db/GetBoardPresident.php`)
    .then(async resp => {
      const jsonResponse = await resp.json()
      setBoardData(jsonResponse);
      setBoardLoading(false);
    })
    .catch(err => {
      setErr(err);
      setBoardLoading(false);
    })
  }

  const fetch10UPassanteCoaches = () => {
//    fetch(`http://softball-pi4/db/GetTravelHeadCoach10U.php`)
    fetch(`https://travel.ehtsoftball.com/db/GetTravelHeadCoach10UPassante.php`)
    .then(async resp => {
      const jsonResponse = await resp.json()
      setCoach10UPassanteData(jsonResponse);
      setCoach10UPassanteLoading(false);
    })
    .catch(err => {
      setErr(err);
      setCoach10UPassanteLoading(false);
    })
  }
  
  const fetch12UBeardCoaches = () => {
//    fetch(`http://softball-pi4/db/GetTravelHeadCoach12U.php`)
    fetch(`https://travel.ehtsoftball.com/db/GetTravelHeadCoach12UBeard.php`)
    .then(async resp => {
      const jsonResponse = await resp.json()
      setCoach12UBeardData(jsonResponse);
      setCoach12UBeardLoading(false);
    })
    .catch(err => {
      setErr(err);
      setCoach12UBeardLoading(false);
    })
  }

  const fetch12UBeckCoaches = () => {
//    fetch(`http://softball-pi4/db/GetTravelHeadCoach12U.php`)
    fetch(`https://travel.ehtsoftball.com/db/GetTravelHeadCoach12UBeck.php`)
    .then(async resp => {
      const jsonResponse = await resp.json()
      setCoach12UBeckData(jsonResponse);
      setCoach12UBeckLoading(false);
    })
    .catch(err => {
      setErr(err);
      setCoach12UBeckLoading(false);
    })
  }

  const fetch14UGentileCoaches = () => {
//    fetch(`http://softball-pi4/db/GetTravelHeadCoach14U.php`)
    fetch(`https://travel.ehtsoftball.com/db/GetTravelHeadCoach14UGentile.php`)
    .then(async resp => {
      const jsonResponse = await resp.json()
      setCoach14UGentileData(jsonResponse);
      setCoach14UGentileLoading(false);
    })
    .catch(err => {
      setErr(err);
      setCoach14UGentileLoading(false);
    })
  }

  const fetch14UGreenCoaches = () => {
//    fetch(`http://softball-pi4/db/GetTravelHeadCoach14U.php`)
    fetch(`https://travel.ehtsoftball.com/db/GetTravelHeadCoach14UGreen.php`)
    .then(async resp => {
      const jsonResponse = await resp.json()
      setCoach14UGreenData(jsonResponse);
      setCoach14UGreenLoading(false);
    })
    .catch(err => {
      setErr(err);
      setCoach14UGreenLoading(false);
    })
  }

  const fetch16UCulliganCoaches = () => {
//    fetch(`http://softball-pi4/db/GetTravelHeadCoach16U.php`)
    fetch(`https://travel.ehtsoftball.com/db/GetTravelHeadCoach16UCulligan.php`)
    .then(async resp => {
      const jsonResponse = await resp.json()
      setCoach16UCulliganData(jsonResponse);
      setCoach16UCulliganLoading(false);
    })
    .catch(err => {
      setErr(err);
      setCoach16UCulliganLoading(false);
    })
  }

/*
  const fetch18UCoaches = () => {
//    fetch(`http://softball-pi4/db/GetTravelHeadCoach18U.php`)
    fetch(`https://www.ehtsoftball.com/db/GetTravelHeadCoach18U.php`)
    .then(async resp => {
      const jsonResponse = await resp.json()
      setCoach18UData(jsonResponse);
      setCoach18ULoading(false);
    })
    .catch(err => {
      setErr(err);
      setCoach18ULoading(false);
    })
  }
*/

  return (
    <div>
      <Banner color="green">Tornadoes Contacts</Banner>
      {boardLoading && (
          <Bullseye>
            <Spinner size="xl" />
          </Bullseye>
        )}
        {!boardLoading && boardData?.length === 0 && (
          <Bullseye>
            <EmptyState titleText="Board President not found" headingLevel="h5" icon={SearchIcon}>
              <EmptyStateBody>
                Check your network connection or contact the system administrator.
              </EmptyStateBody>
            </EmptyState>
          </Bullseye>
        )}
        {!boardLoading && boardData?.map(row => (
        <Card>
          <CardBody>
            <Brand src={Image} alt="Tornadoes Logo" style={{height: '100px', width: '100px'}} />
            <DescriptionList>
              <DescriptionListGroup>
                <DescriptionListTerm>Egg Harbor Township Youth Softball President</DescriptionListTerm>
                <DescriptionListDescription>{row.name}</DescriptionListDescription>
              </DescriptionListGroup>
              <DescriptionListGroup>
                  <DescriptionListTerm>Phone Number</DescriptionListTerm>
                  <DescriptionListDescription>{row.phone}</DescriptionListDescription>
                </DescriptionListGroup>
                <DescriptionListGroup>
                  <DescriptionListTerm>EMail Address</DescriptionListTerm>
                  <DescriptionListDescription>{row.email}</DescriptionListDescription>
                </DescriptionListGroup>
                <DescriptionListGroup>
                  <DescriptionListTerm>Website</DescriptionListTerm>
                  <DescriptionListDescription>
                    <Linkify>
                      <a target="blank" href='https://www.ehtsoftball.com'>Egg Harbor Township Youth Softball</a>                  
                    </Linkify>
                  </DescriptionListDescription>
                </DescriptionListGroup>
             </DescriptionList>
          </CardBody>
        </Card>
      ))}
      <Gallery hasGutter style={{
        [l_gallery_GridTemplateColumns_min.name]: '260px'
      }}>
        {coach10UPassanteLoading && (
          <Bullseye>
            <Spinner size="xl" />
          </Bullseye>
        )}
        {!coach10UPassanteLoading && coach10UPassanteData?.length === 0 && (
          <Bullseye>
            <EmptyState titleText="10U Passante Coaches not found" headingLevel="h5" icon={SearchIcon}>
              <EmptyStateBody>
                Check your network connection or contact the system administrator.
              </EmptyStateBody>
            </EmptyState>
          </Bullseye>
        )}
        {!coach10UPassanteLoading && coach10UPassanteData?.map(row => (
        <Card>
          <CardTitle>
            <Title headingLevel="h4" size="xl">
              10U - Passante
            </Title>
          </CardTitle>
          <CardBody>
            <DescriptionList>
            <DescriptionListGroup>
                <DescriptionListTerm>Head Coach</DescriptionListTerm>
                <DescriptionListDescription>{row.name}</DescriptionListDescription>
              </DescriptionListGroup>
              <DescriptionListGroup>
                <DescriptionListTerm>Phone Number</DescriptionListTerm>
                <DescriptionListDescription>{row.phone}</DescriptionListDescription>
              </DescriptionListGroup>
              <DescriptionListGroup>
                <DescriptionListTerm>EMail Address</DescriptionListTerm>
                <DescriptionListDescription>{row.email}</DescriptionListDescription>
              </DescriptionListGroup>
            </DescriptionList>
          </CardBody>
        </Card>
        ))}
        {coach12UBeardLoading && (
          <Bullseye>
            <Spinner size="xl" />
          </Bullseye>
        )}
        {!coach12UBeardLoading && coach12UBeardData?.length === 0 && (
          <Bullseye>
            <EmptyState titleText="12U Beard Coaches not found" headingLevel="h5" icon={SearchIcon}>
              <EmptyStateBody>
                Check your network connection or contact the system administrator.
              </EmptyStateBody>
            </EmptyState>
          </Bullseye>
        )}
        {!coach12UBeardLoading && coach12UBeardData?.map(row => (
        <Card>
          <CardTitle>
            <Title headingLevel="h4" size="xl">
              12U - Beard
            </Title>
          </CardTitle>
          <CardBody>
            <DescriptionList>
            <DescriptionListGroup>
                <DescriptionListTerm>Head Coach</DescriptionListTerm>
                <DescriptionListDescription>{row.name}</DescriptionListDescription>
              </DescriptionListGroup>
              <DescriptionListGroup>
                <DescriptionListTerm>Phone Number</DescriptionListTerm>
                <DescriptionListDescription>{row.phone}</DescriptionListDescription>
              </DescriptionListGroup>
              <DescriptionListGroup>
                <DescriptionListTerm>EMail Address</DescriptionListTerm>
                <DescriptionListDescription>{row.email}</DescriptionListDescription>
              </DescriptionListGroup>
            </DescriptionList>
          </CardBody>
        </Card>
        ))}
        {!coach12UBeckLoading && coach12UBeckData?.length === 0 && (
          <Bullseye>
            <EmptyState titleText="12U Beck Coaches not found" headingLevel="h5" icon={SearchIcon}>
              <EmptyStateBody>
                Check your network connection or contact the system administrator.
              </EmptyStateBody>
            </EmptyState>
          </Bullseye>
        )}
        {!coach12UBeckLoading && coach12UBeckData?.map(row => (
        <Card>
          <CardTitle>
            <Title headingLevel="h4" size="xl">
              12U - Beck
            </Title>
          </CardTitle>
          <CardBody>
            <DescriptionList>
            <DescriptionListGroup>
                <DescriptionListTerm>Head Coach</DescriptionListTerm>
                <DescriptionListDescription>{row.name}</DescriptionListDescription>
              </DescriptionListGroup>
              <DescriptionListGroup>
                <DescriptionListTerm>Phone Number</DescriptionListTerm>
                <DescriptionListDescription>{row.phone}</DescriptionListDescription>
              </DescriptionListGroup>
              <DescriptionListGroup>
                <DescriptionListTerm>EMail Address</DescriptionListTerm>
                <DescriptionListDescription>{row.email}</DescriptionListDescription>
              </DescriptionListGroup>
            </DescriptionList>
          </CardBody>
        </Card>
        ))}
        {coach14UGentileLoading && (
          <Bullseye>
            <Spinner size="xl" />
          </Bullseye>
        )}
        {!coach14UGentileLoading && coach14UGentileData?.length === 0 && (
          <Bullseye>
            <EmptyState titleText="14U Gentile Coaches not found" headingLevel="h5" icon={SearchIcon}>
              <EmptyStateBody>
                Check your network connection or contact the system administrator.
              </EmptyStateBody>
            </EmptyState>
          </Bullseye>
        )}
        {!coach14UGentileLoading && coach14UGentileData?.map(row => (
        <Card>
          <CardTitle>
            <Title headingLevel="h4" size="xl">
              14U - Gentile
            </Title>
          </CardTitle>
          <CardBody>
            <DescriptionList>
            <DescriptionListGroup>
                <DescriptionListTerm>Head Coach</DescriptionListTerm>
                <DescriptionListDescription>{row.name}</DescriptionListDescription>
              </DescriptionListGroup>
              <DescriptionListGroup>
                <DescriptionListTerm>Phone Number</DescriptionListTerm>
                <DescriptionListDescription>{row.phone}</DescriptionListDescription>
              </DescriptionListGroup>
              <DescriptionListGroup>
                <DescriptionListTerm>EMail Address</DescriptionListTerm>
                <DescriptionListDescription>{row.email}</DescriptionListDescription>
              </DescriptionListGroup>
            </DescriptionList>
          </CardBody>
        </Card>
        ))}
        {!coach14UGreenLoading && coach14UGreenData?.length === 0 && (
          <Bullseye>
            <EmptyState titleText="14U Green Coaches not found" headingLevel="h5" icon={SearchIcon}>
              <EmptyStateBody>
                Check your network connection or contact the system administrator.
              </EmptyStateBody>
            </EmptyState>
          </Bullseye>
        )}
        {!coach14UGreenLoading && coach14UGreenData?.map(row => (
        <Card>
          <CardTitle>
            <Title headingLevel="h4" size="xl">
              14U - Green
            </Title>
          </CardTitle>
          <CardBody>
            <DescriptionList>
            <DescriptionListGroup>
                <DescriptionListTerm>Head Coach</DescriptionListTerm>
                <DescriptionListDescription>{row.name}</DescriptionListDescription>
              </DescriptionListGroup>
              <DescriptionListGroup>
                <DescriptionListTerm>Phone Number</DescriptionListTerm>
                <DescriptionListDescription>{row.phone}</DescriptionListDescription>
              </DescriptionListGroup>
              <DescriptionListGroup>
                <DescriptionListTerm>EMail Address</DescriptionListTerm>
                <DescriptionListDescription>{row.email}</DescriptionListDescription>
              </DescriptionListGroup>
            </DescriptionList>
          </CardBody>
        </Card>
        ))}
        {coach16UCulliganLoading && (
          <Bullseye>
            <Spinner size="xl" />
          </Bullseye>
        )}
        {!coach16UCulliganLoading && coach16UCulliganData?.length === 0 && (
          <Bullseye>
            <EmptyState titleText="16U Culligan Coaches not found" headingLevel="h5" icon={SearchIcon}>
              <EmptyStateBody>
                Check your network connection or contact the system administrator.
              </EmptyStateBody>
            </EmptyState>
          </Bullseye>
        )}
        {!coach16UCulliganLoading && coach16UCulliganData?.map(row => (
        <Card>
          <CardTitle>
            <Title headingLevel="h4" size="xl">
              16U - Culligan
            </Title>
          </CardTitle>
          <CardBody>
            <DescriptionList>
            <DescriptionListGroup>
                <DescriptionListTerm>Head Coach</DescriptionListTerm>
                <DescriptionListDescription>{row.name}</DescriptionListDescription>
              </DescriptionListGroup>
              <DescriptionListGroup>
                <DescriptionListTerm>Phone Number</DescriptionListTerm>
                <DescriptionListDescription>{row.phone}</DescriptionListDescription>
              </DescriptionListGroup>
              <DescriptionListGroup>
                <DescriptionListTerm>EMail Address</DescriptionListTerm>
                <DescriptionListDescription>{row.email}</DescriptionListDescription>
              </DescriptionListGroup>
            </DescriptionList>
          </CardBody>
        </Card>
        ))}
      </Gallery>
    </div>
  );
}

export default Contacts;

